import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { Form } from 'factorial-form'
import moment from 'moment'

import DayPicker from 'modules/core/components/Inputs/DayPicker'
import { useMemo } from 'modules/core/hooks/useMemo'
import { dateToString, stringToDate } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

import type { Automation } from 'modules/automations/store/models/Automation'

export interface Props {
  automation: Automation
  selectedMonthday?: string
  setSelectedMonthday: (day: string) => void
}

export default function Yearly({ selectedMonthday, setSelectedMonthday, automation }: Props) {
  const form = useMemo(() => {
    const monthDay = automation.attributes.repeat_data?.split(' ')
    return new Form(
      {
        repeat_data: monthDay
          ? dateToString(
              moment()
                .set('date', Number(monthDay[0]))
                .set('month', Number(monthDay[1]) - 1),
              'ui'
            )
          : undefined,
      },
      {
        repeat_data: 'string',
      }
    )
  }, [automation.attributes.repeat_data])

  const pickedDayTranslation = useMemo(() => {
    const monthDay = selectedMonthday?.split(' ')
    const dayNumber = moment().date(Number(monthDay?.[0])).format('D')
    const month = moment()
      .month(Number(monthDay?.[1]) - 1)
      .format('MMMM')
    return i18n.t('automations.new.subtitle_yearly_trigger', { day: dayNumber, month })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [form.get('repeat_data').value, selectedMonthday])

  return (
    <>
      <DayPicker
        label={i18n.t('automations.actions.time.monthly_label')}
        field={form.get('repeat_data')}
        onChange={(field) => {
          const monthDay = `${stringToDate(field.value, 'ui').date()} ${
            stringToDate(field.value, 'ui').month() + 1
          }`
          setSelectedMonthday(monthDay)
        }}
      />

      <Box paddingTop="s16">{pickedDayTranslation}</Box>
    </>
  )
}
